import * as t from  './actionTypes';
import * as api from './api';

export function loadCoupon() {

    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });

        api.getCoupon((success, coupon, error) => {
            if (success) {
                dispatch({ type: t.COUPON_LOAD_SUCCESS, coupon: coupon });
                dispatch({ type: t.UNSET_BUSY });
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
            }
        });
    }
}

export function setCoupons(data, successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });
        api.setCoupons(data, function(success, data, error) {
            if (success) {
                dispatch({ type: t.COUPON_CHANGE_SUCCESS, coupon: data });
                dispatch({ type: t.UNSET_BUSY });
                successCB();
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
                errorCB(error);
            }
        });
    }
}

export function updateCoupons(data, successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });
        api.updateCoupons(data, function(success, data, error) {
            if (success) {
                dispatch({ type: t.COUPON_CHANGE_SUCCESS, coupon: data });
                dispatch({ type: t.UNSET_BUSY });
                successCB();
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
                errorCB(error);
            }
        });
    }
}

export function createBarcode(id, data, successCB, errorCB) {
    return (dispatch) => {

        api.createBarcode(id, data, function(success, data, error) {
            if (success) {
                dispatch({ type: t.COUPON_CREATE_BARCODE, id: id, coupon: data });
                dispatch({ type: t.UNSET_BUSY });
                successCB();
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
                errorCB(error);
            }
        })
    }
}
